'use client';

import { useEffect, useRef } from 'react';
import {
  AD_DEFER_IDLE_MEDIAG_MS,
  scheduleDeferredAdLoad,
} from '../../../lib/ad-script-defer';

/** Carrega GPT + Membrana quando o slot está próximo da viewport. */
const MEMBRANA_IO_ROOT_MARGIN = '200px 0px';

/**
 * Membrana OTF Video (yieldMaster) — alinhado a tvfoco-frontend PostMidContentAds.
 */
export default function PostMidContentAds() {
  const membranaStartedRef = useRef(false);
  const slotRef = useRef(null);

  useEffect(() => {
    const el = slotRef.current;
    if (!el || typeof window === 'undefined') return;

    let cancelDefer = () => {};

    const startMembranaMediaOtf = () => {
      if (membranaStartedRef.current) return;
      membranaStartedRef.current = true;

      cancelDefer = scheduleDeferredAdLoad(
        () => {
          const head = document.getElementsByTagName('head')[0];
          if (!head) return;

          const append = (src) => {
            if (document.querySelector(`script[src="${src}"]`)) return;
            const t = document.createElement('script');
            t.async = true;
            t.src = src;
            t.setAttribute('data-ad-deferred', '1');
            head.appendChild(t);
          };

          append('https://securepubads.g.doubleclick.net/tag/js/gpt.js');
          append('https://cdn.membrana.media/otf/ym.js');

          window.yieldMasterCmd = window.yieldMasterCmd || [];
          window.yieldMasterCmd.push(function () {
            if (window.yieldMaster && typeof window.yieldMaster.init === 'function') {
              window.yieldMaster.init({
                pageVersionAutodetect: true,
              });
            }
          });
        },
        { idleTimeout: AD_DEFER_IDLE_MEDIAG_MS }
      );
    };

    let io;
    try {
      io = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            startMembranaMediaOtf();
            if (io) io.disconnect();
          }
        },
        { root: null, rootMargin: MEMBRANA_IO_ROOT_MARGIN, threshold: 0 }
      );
      io.observe(el);
    } catch {
      startMembranaMediaOtf();
    }

    return () => {
      cancelDefer();
      if (io) io.disconnect();
    };
  }, []);

  return (
    <div className="post-mid-content-ads">
      <div
        ref={slotRef}
        id="membrana-post-rm"
        className="adsbgnew post-membrana-slot"
      >
        <div className="OTF_VIDEO post-membrana-video" />
      </div>
    </div>
  );
}
